import { render, staticRenderFns } from "./botPostDetail.vue?vue&type=template&id=76554c5a&"
import script from "./botPostDetail.vue?vue&type=script&lang=js&"
export * from "./botPostDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports